import { useMutation, useQueryClient } from '@tanstack/react-query'
import { LobsterMasterApi } from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { getLobsterApiErrorDetail } from './getLobsterApiErrorDetail'
import { labelMasterQueryKeys } from './queryKeys'

export const useDeleteLabelMaster = () => {
  const queryClient = useQueryClient()
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (id: string) =>
      baseClient.getApi(LobsterMasterApi).deleteInternalLabelMaster({ id }),
    onSuccess: () => {
      showSuccessSnackbar('削除に成功しました')
      queryClient.invalidateQueries({
        queryKey: labelMasterQueryKeys.labelMasters.all,
      })
    },
    onError: async error => {
      const detail = await getLobsterApiErrorDetail(error)
      showErrorSnackbar(
        detail ??
          'ラベルマスタの削除に失敗しました。しばらく経ってから再度お試しください。',
      )
    },
  })
}
